<template lang="html">
<div class="station-details surface-quality">

    <div class="loading" v-if="!queryDone">
        <p>Loading station data...</p>
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div class="station" v-if="station && queryDone">

        <h3 class="headline station-name primary--text" v-text="queryData.name"></h3>

        <p class="body-2 mb-1 network-info">
            {{ networkId }}<br>
            <a target="_blank" :href="networkUrl">{{ network }}</a>
        </p>

        <hr class="my-3">

        <div
        v-for="{ title, value } in properties"
        v-if="value"
        class="properties-item mb-3">
            <h4 class="subheading field-title grey--text" v-text="title"></h4>
            <div class="body-1 field-value" v-text="value"></div>
        </div>

        <hr class="my-3">

        <h4 class="subheading field-title grey--text">Parameters</h4>

        <v-btn
        class="my-3"
        block
        large
        @click="showChartModal('surface-water-quality')"
        color="primary">
            <v-icon left>table_chart</v-icon>
            View Table
        </v-btn>

        <download-csv-button :redistribute="dataRedistirbute" :station-id="stationId" />

        <div v-for="sparkline in visibleSparklines"
        class="sparkline-wrap elevation-1"
        :key="`${sparkline.paramId}__${sparkline.units}`">
            <spark-line :data="sparkline" />
            <div class="hover-cta">
                <v-btn @click="showSingleChart(sparkline)">View more...</v-btn>
            </div>
        </div>

        <v-btn
        v-show="numVisibleSparklines < this.sparklineData.length"
        block
        @click="addCharts"
        color="info">
            More Charts
        </v-btn>
    </div>
    <single-chart-modal
    v-if="showSingleChartModal"
    :show="showSingleChartModal"
    :chartDetails="chartDetails"
    @close="showSingleChartModal = false" />
</div>
</template>

<script>
import pluralize from 'pluralize';

import * as actions from '@/constants/actions';
import SparkLine from '@/components/D3SparklineWrapper';
import surfaceQualityData from '@/mixins/surfaceQualityData';
import getStationMetadata from '@/mixins/getStationMetadata';
import SingleChartModal from '@/components/SingleChartModal';
import DownloadCsvButton from '@/components/DownloadCsvButton';

export default {
    name: 'station-details-surface-quality',
    components: {
        SparkLine,
        SingleChartModal,
        DownloadCsvButton,
    },
    mixins: [
        surfaceQualityData,
        getStationMetadata,
    ],
    async mounted() {
        await this.getData();
    },
    data() {
        return {
            allChartData: null,
            numVisibleSparklines: 5,
            chartDetails: null,
        };
    },
    computed: {
        stationId() {
            return this.station.id;
        },
        visibleSparklines() {
            return this.sparklineData.slice(0, this.numVisibleSparklines);
        },
    },
    methods: {
        addCharts() {
            this.numVisibleSparklines += 5;
        },
        pluralize(term, num) {
            return pluralize(term, num);
        },
        showChartModal(tabName) {
            this.$store.dispatch(actions.SET_CHART_MODAL_TAB, tabName);
            this.$store.dispatch(actions.SHOW_CHART_MODAL, true);
        },
        /**
         * display a modal window showing a single chart
         * @param  {Object} chart data object with name & data keys
         */
        async showSingleChart(chart) {
            const { paramId, title, units } = chart;
            this.chartDetails = {
                stationId: this.stationId,
                paramId,
                title,
                units,
            };
            this.showSingleChartModal = true;
        },
    },
    watch: {
        async station() {
            this.numVisibleSparklines = 5;
            await this.getData();
        },
    },
};
</script>

<style scoped lang="scss">
.station-details {
    a {
        text-decoration: none;
        color: #000;
    }

    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 5rem;
    }

    .sparkline-wrap {
        position: relative;
        margin-bottom: .6rem;

        &:hover {
            .hover-cta {
                opacity: 1;
            }
        }

        .hover-cta {
            transition: opacity .25s;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(25, 25, 25, .5);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarStationSurfaceQuality.vue